import { ApiServiceV1 } from './api.service';

export const SettingsApiService = {
  async getDigitalSettings({ suffix }) {
    const { data } = await ApiServiceV1(`${suffix}/settings`);

    return data || {};
  },
};
